<div class="tab tab--bottom">
  <button appTooltip="Attribute Table" tooltipPosition="top" (click)="openBottomSheet()"><span><i class="fa fa-lg fa-table"></i></span></button>
</div>
